/// REDUX ///
import { Dispatch } from "redux";
/// ACTIONS ///
import { Action } from "api/action_types/event";
/// ACTION TYPES ///
import { ActionType } from "api/action_types/event";
/// TYPES ///
import { ISelfOrderEvent } from "api/types/event";

export const setSelfOrderEvent = (event: ISelfOrderEvent) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.SET_SELF_ORDER_EVENT,
      event
    })
  }
}
